<template>
  <v-app>
    <v-main v-bind:style="stylePagina">
      <v-container >
        <v-dialog
            :value="alertnuevo"
            persistent
            max-width="380"
        >
          <v-card>
            <v-card-title class="text-h5">
              {{ $t('alertas.titulodatos') }}
            </v-card-title>
            <v-card-text>{{ $t('alertas.nuevosocio') }}</v-card-text>
            <v-card-actions>
              <v-btn
                  color="green darken-1"
                  text
                  @click="alertnuevo = false"
              >
                OK
              </v-btn>
            </v-card-actions>
          </v-card>

        </v-dialog>
        <section id="main-cabecera" class="mb-4">
          <v-row align="center" class="text-center">
            <v-col cols="12" sm="12" md="12" lg="12">
              <h1 v-if="logoexist" class="display-1 font-weight-bold">
                <v-img style="width: 25%;" :src="logoimg" />
              </h1>
              <h1 v-else>{{titulonegocio}}</h1>
            </v-col>
          </v-row>
          <v-row  justify="space-between">
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-form ref="form">
                <v-row>
                  <v-col  cols="6" sm="6" md="4">
                    <v-autocomplete  v-model="editedItem.personaSocioDTO.personaTipoDocumentoId" :items="tiposdoc" item-value="tipoDocumentoId" item-text="tipoDocumento"  persistent-hint
                                     return-object
                                     single-line :label="$t('formularios.EscogerTipoDoc')"></v-autocomplete>
                  </v-col>
                  <v-col cols="6" sm="6" md="4">
                    <v-text-field v-model="editedItem.personaSocioDTO.personaDni" :label="$t('formularios.DNI')" required></v-text-field>
                  </v-col>
                  <v-col cols="6" sm="6" md="4">
                    <v-text-field v-model="editedItem.personaSocioDTO.personaEmail" :label="$t('formularios.Email')" :rules="emailRules" required></v-text-field>
                  </v-col>
                <v-col cols="6" sm="6" md="4">
                  <v-text-field v-model="editedItem.personaSocioDTO.personaNombre" :label="$t('formularios.nombres')"></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="4">
                  <v-text-field v-model="editedItem.personaSocioDTO.personaApellidoPaterno" :label="$t('formularios.ApPaterno')"></v-text-field>
                </v-col>
                <v-col v-if="campoapmaterno" cols="6" sm="6" md="4">
                  <v-text-field v-model="editedItem.personaSocioDTO.personaApellidoMaterno" :label="$t('formularios.ApMaterno')"></v-text-field>
                </v-col>
                <v-col v-if="campotelefono" cols="6" sm="6" md="4">
                  <v-text-field type="number" v-model="editedItem.personaSocioDTO.personaTelefono" :label="$t('formularios.Telefono')"></v-text-field>
                </v-col>
                <v-col v-if="campodireccion" cols="6" sm="6" md="4">
                  <v-text-field  v-model="editedItem.personaSocioDTO.personaDireccion" :label="$t('formularios.Direccion')"></v-text-field>
                </v-col>
                  <v-col v-if="campodistrito" cols="6" sm="6" md="4">
                    <v-autocomplete  v-model="editedItem.personaSocioDTO.personaPaisId" :items="paises" item-value="paisId" item-text="pais" persistent-hint
                                     return-object
                                     @change="cambiopais"
                                     single-line label="Escoger Pais"></v-autocomplete>
                  </v-col>
                  <v-col v-if="campodistrito" cols="6" sm="6" md="4">
                    <v-autocomplete  v-model="editedItem.personaSocioDTO.personaProvinciaId" :items="provincias" item-value="provinciaId" item-text="provincia" persistent-hint
                                     return-object
                                     @change="cambioprovincia"
                                     single-line label="Escoger Departamento"></v-autocomplete>
                  </v-col>
                  <v-col v-if="campodistrito" cols="6" sm="6" md="4">
                    <v-autocomplete  v-model="editedItem.personaSocioDTO.personaCiudadId" :items="ciudades" item-value="ciudadId" item-text="ciudad" persistent-hint
                                     return-object
                                     @change="cambiociudad"
                                     single-line label="Escoger Provincia"></v-autocomplete>
                  </v-col>
                <v-col v-if="campodistrito" cols="6" sm="6" md="4">
                  <v-autocomplete  v-model="editedItem.personaSocioDTO.personaDistritoId" :items="distritos" item-value="distritoId" item-text="distrito" persistent-hint
                                   return-object
                                   single-line :label="$t('formularios.EscogerDistrito')"></v-autocomplete>
                </v-col>
                  <v-col v-if="camposexo" cols="6" sm="6" md="4">
                    <v-autocomplete  v-model="editedItem.personaSocioDTO.personaSexoId" :items="sexos" item-value="idSexo" item-text="Sexo"  persistent-hint
                                      return-object
                                     single-line :label="$t('formularios.EscogerSexo')"></v-autocomplete>
                  </v-col>
                  <v-col v-if="campofecnac" cols="6" sm="6" md="4">
                    <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="editedItem.personaSocioDTO.personaFechaNacimiento" :label="$t('formularios.FechaNacimiento')"
                                      hint="YYYY-MM-DD" persistent-hint
                                      @blur="date = formatDate(editedItem.personaSocioDTO.personaFechaNacimiento)"
                                      v-on="on"
                                      prepend-icon="fas fa-calendar" ></v-text-field></template>
                      <v-date-picker
                          v-model="date"
                          no-title
                          min="1950-01-01"
                          locale="es-es"
                          :first-day-of-week="1"
                          @input="menu1 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col v-if="campotipocarnet" cols="6" sm="6" md="6">
                    <v-autocomplete  v-model="editedItem.tipoCarnetSocioDTO.tipoCarnetId" :items="tiposcarnets" item-value="tipoCarnetId" item-text="tipoCarnet" :hint="$t('formularios.TipoCarnet')" persistent-hint
                                     return-object
                                     single-line :label="$t('formularios.EscogerTipoCar')"></v-autocomplete>
                  </v-col>
                  <v-col v-if="camporeferido" cols="6" sm="6" md="4">
                    <v-text-field  v-model="editedItem.referido" :label="$t('formularios.Referido')"></v-text-field>
                  </v-col>
                  <v-col v-if="campofumador" cols="12" sm="12" md="4">
                    <v-radio-group
                        v-model="editedItem.personaSocioDTO.personaFumador"
                        :label="$t('formularios.Fumas')"
                        row
                        mandatory
                    >
                      <v-radio
                          :label="$t('formularios.Si')"
                          value="true"
                      ></v-radio>
                      <v-radio
                          :label="$t('formularios.No')"
                          value="false"
                      ></v-radio></v-radio-group>
                  </v-col>
                  <v-col v-if="campocondiciones" cols="12" sm="12" md="12">

                  <v-checkbox
                      v-model="editedItem.aceptoCondicion"
                      :rules="[v => !!v || 'Debes aceptar para continuar']"
                      :label="condiciones"
                      required
                  ></v-checkbox>  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn v-bind:style="btnPag"  @click="save">Grabar</v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
        </section>
        <v-overlay :value="overlay">
          <v-progress-circular
              indeterminate
              size="64"
          ></v-progress-circular>
        </v-overlay>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from 'axios';
import md5 from 'js-md5';
import moment from "moment";
import firebase from 'firebase/compat/app';

export default {
  title: 'Inscripcion | Tunay Mi acceso de bolsillo',

  name: "eventosinscripcion",
  metaInfo() {
    return {
      title: this.titulonegocio,
        meta: [
      {property: "og:image", content: this.logoimg},
      {property: "og:image:width", content: "699"},
      {property: "og:image:height", content: "366"},
      {
        property: "og:description",
        content: "Inscripción de socios a "+this.titulonegocio
      }
    ]
    }
  },
  data () {
    return{
      idnegocio: 0,
      overlay:false,
      alertnuevo:false,
      token:'',
      logoexist: false,
      logoimg: null,
      emailRules: [
        v => !!v || 'E-mail es requerido',
        v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
      ],
      titulonegocio:'',
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      campoapmaterno: false,
      campodireccion: false,
      campodistrito: false,
      campofecnac: false,
      campofoto: false,
      campoinvitado: false,
      campoizqder: false,
      camporeferido: false,
      camposexo: false,
      campotelefono: false,
      campofumador: false,
      campotipocarnet: false,
      campocondiciones:false,
      condiciones: '',
      paises:[],
      provincias:[],
      ciudades:[],
      distritos: [{distritoId:0,distrito:"Escoger Distrito",ciudadDTO:{
          ciudadId: 0,
          ciudadNombre: "",
          provinciaId: 0,
          provinciaNombre: "",
          paisId: 0,
          paisNombre: ""
        }}],
      sexos: [{idSexo:0,Sexo:"Escoger Sexo"}, {idSexo:1, Sexo:"Masculino"}, {idSexo:2, Sexo:"Femenino"}],
      tiposdoc: [{tipoDocumentoId:0,tipoDocumento:"Escoger Tipo de Documento"}, {tipoDocumentoId:1, tipoDocumento:"DNI"}, {tipoDocumentoId:2, tipoDocumento:"Carnet Extranjeria"}, {tipoDocumentoId:3, tipoDocumento:"Pasaporte"}],
      negocio:[],
      tiposcarnets:[],
      negociodisenio: [],
      editedItem: {
        historiaSocioId:0,
        fecha: '2021-01-01 00:00:00',
        estadoCarnetDTO: {
          estadoCarnetId: 0,
          estadoCarnetNombre: '',
          estadoCarnetColor: ''
        },
        formaEnvioDTO: {
          formaEnvioId:0,
          formaEnvioNombre: ''
        },
        tipoPagoDTO : {
          tipoPagoId: 0,
          tipoPagoNombre: ''
        },
        tipoMembresiaDTO: {
          tipoMembresiaId: 0,
          tipoMembresiaNombre: ''
        },
        tipoCarnetSocioDTO:{
          tipoCarnetId: 0,
          tipoCarnetNombre: '',
          negocioId:0,
          negocioNombre:'',
          negocioIcono:'',
          negocioLogo: '',
          clienteId:0,
          clienteNombre:''
        },
        temporadaDTO:{
          temporadaId:0,
          temporadaNombre:''
        },
        contactoDTO:{
          contactoId:0,
          contactoNombre:''
        },
        referido:'',
        nroboleta: '',
        valorpago:0,
        aceptoCondicion:false,
        condicionAceptada:'',
        usuarioDTO:{
          usuarioId:0,
          usuarioNombre:'',
          usuarioEmail:'',
          usuarioFirebase:''
        },
        personaSocioDTO: {
          personaId:0,
          personaNombre:'',
          personaApellidoPaterno:'',
          personaApellidoMaterno:'',
          personaSexoId:0,
          personaSexo:'',
          personaDistritoId:'',
          personaDistrito:'',
          personaCiudadId:129,
          personaCiudad:'Lima',
          personaProvinciaId:15,
          personaProvincia:'Lima',
          personaPaisId:173,
          personaPais:'Perú',
          personaDireccion:'',
          personaDni:'',
          personaFoto:'',
          personaDniFoto:'',
          personaFechaNacimiento:'',
          personaTelefono:'',
          personaEmail:'',
          personaPaisNacId:0,
          personaPaisNac:'',
          personaFumador: false,
          personaTipoDocumentoId: 0,
          personaTipoDocumento:''
        }
      },
      stylePagina: {
        backgroundColor: 'white',
        color:'white'
      },
      btnPag: {
        backgroundColor: 'blue',
        color:'white'
      }

    }
  }
  ,
  mounted (){
    this.idnegocio =  this.$route.params.idnegocio;
    this.damedisenio();
    this.damepaises();
  }
,
watch: {
  date () {
    this.editedItem.personaSocioDTO.personaFechaNacimiento = this.formatDatee(this.date)
  }
},

  methods: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    formatDatee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD")
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${year}-${month}-${day}`;
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    cambiopais(){
      this.editedItem.personaSocioDTO.personaPais = this.editedItem.personaSocioDTO.personaPaisId.pais
      this.editedItem.personaSocioDTO.personaPaisId = this.editedItem.personaSocioDTO.personaPaisId.paisId
      this.dameprovincias()
    },
    cambioprovincia(){
      this.editedItem.personaSocioDTO.personaProvinciaNombre = this.editedItem.personaSocioDTO.personaProvinciaId.provincia
      this.editedItem.personaSocioDTO.personaProvinciaId = this.editedItem.personaSocioDTO.personaProvinciaId.provinciaId
      this.dameciudades()
    },
    cambiociudad(){
      this.editedItem.personaSocioDTO.personaCiudadNombre = this.editedItem.personaSocioDTO.personaCiudadId.ciudad
      this.editedItem.personaSocioDTO.personaCiudadId = this.editedItem.personaSocioDTO.personaCiudadId.ciudadId
      this.damedistritos()
    },
    damepaises(){
      this.progr = true;
      axios
          .get('paises')
          .then(response => {
            this.paises = response.data;
            this.dameprovincias()
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    dameprovincias(){
      this.progr = true;
      axios
          .get('provincias/pais/'+this.editedItem.personaSocioDTO.personaPaisId)
          .then(response => {
            this.provincias = response.data;
            this.dameciudades()

          })
          .catch((error)  => {
            console.log(error);
          });
    },
    dameciudades(){
      this.progr = true;
      axios
          .get('ciudades/provincia/'+this.editedItem.personaSocioDTO.personaProvinciaId)
          .then(response => {
            this.ciudades = response.data;
            this.damedistritos()
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    damedistritos(){
      this.progr = true;
      axios
          .get('distritos/ciudad/'+this.editedItem.personaSocioDTO.personaCiudadId)
          .then(response => {
            this.distritos = response.data;
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    damenegocio(negociotag){
      this.progr = true;

      axios
          .get('negocios/tag/'+negociotag)
          .then(response => {
            this.negocio = response.data;
           this.damecarnetsnegocio();
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    damecarnetsnegocio(){
      this.progr = true;
      var bodyFormData = new FormData();
      bodyFormData.append('negociotag', md5(this.idnegocio+'tcc'));
      bodyFormData.append('idtemporada', this.negocio.temporadaActivaDTO.temporadaActivaId);

      axios
          .post('tipocarnets/negociotemporada',bodyFormData)
          .then(response => {
            this.tiposcarnets = response.data;
            if (this.tiposcarnets.lenght>1){
              this.campotipocarnet=true

            }else{
              this.campotipocarnet = false
              let tipcrnt = {
                tipoCarnetId: this.tiposcarnets[0].tipoCarnetId,
                tipoCarnetNombre: this.tiposcarnets[0].tipoCarnet,
                negocioId:this.tiposcarnets[0].negocioDTO.negocioId,
                negocioNombre:this.tiposcarnets[0].negocioDTO.negocioNombre,
                negocioIcono:this.negocio.icono,
                negocioLogo:this.tiposcarnets[0].negocioDTO.negocioLogo,
                clienteId:this.negocio.clienteDTO.clienteId,
                clienteNombre:this.negocio.clienteDTO.clienteNombre
              }
              this.editedItem.tipoCarnetSocioDTO = tipcrnt
            }
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    save () {
      this.overlay = true;
      this.editedItem.personaSocioDTO.personaDistrito = this.editedItem.personaSocioDTO.personaDistritoId.distrito;
      this.editedItem.personaSocioDTO.personaDistritoId = this.editedItem.personaSocioDTO.personaDistritoId.distritoId;
      this.editedItem.personaSocioDTO.personaSexo = this.editedItem.personaSocioDTO.personaSexoId.Sexo;
      this.editedItem.personaSocioDTO.personaSexoId = this.editedItem.personaSocioDTO.personaSexoId.idSexo;
      this.editedItem.personaSocioDTO.personaTipoDocumento = this.editedItem.personaSocioDTO.personaTipoDocumentoId.tipoDocumento;
      this.editedItem.personaSocioDTO.personaTipoDocumentoId = this.editedItem.personaSocioDTO.personaTipoDocumentoId.tipoDocumentoId;
      this.editedItem.usuarioDTO.usuarioEmail = this.editedItem.personaSocioDTO.personaEmail;
      let temporadaobj= {
        temporadaId : this.negocio.temporadaActivaDTO.temporadaActivaId,
        temporadaNombre: this.negocio.temporadaActivaDTO.temporadaActivaNombre
      };
      this.editedItem.temporadaDTO = temporadaobj;
      let tipopagoobj= {
        tipoPagoId : this.negociodisenio.tipoPagoDTO.tipoPagoId,
        tipoPagoNombre: this.negociodisenio.tipoPagoDTO.tipoPagoNombre
      };
      this.editedItem.tipoPagoDTO = tipopagoobj;

      var bodyFormData2 = new FormData();
      bodyFormData2.append("email",this.editedItem.personaSocioDTO.personaEmail);
      bodyFormData2.append("dni",this.editedItem.personaSocioDTO.personaDni);

      axios
          .post('usuarios/emaildni',bodyFormData2).then(response => {
        let usuariodto = response.data
        if(usuariodto.existeusuario){
           if(usuariodto.firebasecreado){
              this.grabasocio();
           }else{
             this.creafirebase();
           }
        }else{
          this.creafirebase();
        }

        this.alertnuevo = true;
        this.overlay = false;
        this.$refs.form.reset()
      })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
          });


    },
    creafirebase(){
      let correo = this.editedItem.personaSocioDTO.personaEmail
      firebase
          .auth()
          .createUserWithEmailAndPassword(correo,'usuario')
          .then(data => {
            this.editedItem.usuarioDTO.usuarioFirebase = data.user.uid
            this.grabasocio()
          })
          .catch(err => {
            if(err.code === "auth/user-not-found"){
              this.error = "No Existe este Email en nuestra base de datos";
            }else{
              this.error = "Puede haber un error con el email y/o password";
            }
          });
    },

    grabasocio(){
      var bodyFormData = new FormData();
      bodyFormData.append("data",JSON.stringify(this.editedItem));
      axios
          .post('historiasocios/nuevo',bodyFormData).then(responsee => {
        console.log(responsee);
        this.alertnuevo = true;
        this.overlay = false;
        this.$refs.form.reset()
      })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
          });
    },
    damedisenio(){
      this.progr = true;
      var bodyFormData = new FormData();
      bodyFormData.append('hasp', this.idnegocio);
      axios
          .post('negociodisenio',bodyFormData)
          .then(response => {
            this.negociodisenio = response.data;
            this.campoapmaterno= this.negociodisenio.campoapmaterno;
            this.campotelefono = this.negociodisenio.campotelefono;
            this.campoinvitado = this.negociodisenio.campoinvitado;
            this.camposexo = this.negociodisenio.camposexo;
            this.campodireccion = this.negociodisenio.campodireccion;
            this.campodistrito = this.negociodisenio.campodistrito;
            this.campofecnac  = this.negociodisenio.campofecnac;
            this.campofumador = this.negociodisenio.campofumador;
            this.damenegocio(this.negociodisenio.negocioDTO.negocioTag);
            if (this.negociodisenio.negocioDTO.negocioLogo === null){
                this.logoexist = false;
            }else{
              this.logoexist  = true;
              this.logoimg = this.negociodisenio.negocioDTO.negocioLogo;
            }
            if (this.negociodisenio.condiciones !== '' && this.negociodisenio.condiciones !== null){
              this.campocondiciones = true
              this.condiciones = this.negociodisenio.condiciones
              this.editedItem.condicionAceptada = this.condiciones
            }

            this.titulonegocio = this.negociodisenio.negocioDTO.negocioNombre;
            let objPag= {
              backgroundColor: this.negociodisenio.backgroundColor,
              color:this.negociodisenio.colorText
            }
            let btnPag= {
              backgroundColor: this.negociodisenio.colorBgBoton,
              color:this.negociodisenio.colorTxtBoton
            }
            this.btnPag = btnPag
            this.stylePagina = objPag
          })
          .catch((error)  => {
            console.log(error);
          });
    }
  }
}
</script>

<style scoped>

</style>